import type { Iti } from 'intl-tel-input';

const MAX_VALUE_LENGTH = 16;

const doesPassMaxLength = (value: string) => value.length <= MAX_VALUE_LENGTH;

const isDigitOrPlus = (value: string) => /^([+0-9]*)$/.test(value);

export const isValueValid = (value: string) => doesPassMaxLength(value) && isDigitOrPlus(value);

const removeSpace = (value: string) => value.replace(/\s+/g, '');
const removeMinus = (value: string) => value.replace(/-/g, '');
const removeDecimal = (value: string) => value.replace(/\./g, '');
const removeParenthesis = (value: string) => value.replace(/\(/g, '').replace(/\)/g, '');

export const sanitizeInputNumber = (tel: string) =>
  removeParenthesis(removeDecimal(removeMinus(removeSpace(tel))));

export const getTelNumber = ({ tel, iti }: { tel: string; iti?: Iti }) => {
  const countryData = iti?.getSelectedCountryData();
  const dialCode = countryData?.dialCode;

  if (!tel.length || !dialCode) {
    return null;
  }

  let number = tel;

  if (dialCode) {
    number = number.replace(`+${dialCode}`, '');
  }

  return { countryCode: `+${dialCode}`, number };
};
